<div class="conf2-sign-in-failure" role="alert">
  <p class="title">{{ message.title }}</p>
  <p class="text">{{ message.text }}</p>
</div>
